import { render, staticRenderFns } from "./FinalizadoComponent.vue?vue&type=template&id=28f023ea&scoped=true"
import script from "./FinalizadoComponent.vue?vue&type=script&lang=js"
export * from "./FinalizadoComponent.vue?vue&type=script&lang=js"
import style0 from "./FinalizadoComponent.vue?vue&type=style&index=0&id=28f023ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f023ea",
  null
  
)

export default component.exports